import { registerTidalVersion } from "@workwave-tidal/core/base";
import * as core from "./core/index.js";
export * from "./fields/index.js";
import * as hooks from "./hooks/index.js";
import * as layout from "./layout/index.js";
import * as utils from "./utils/index.js";
try {
  const tidalName = "@workwave-tidal/form-ui";
  const tidalVersion = "4.6.4";
  registerTidalVersion(tidalName, tidalVersion);
} catch (e) {
}
export {
  core,
  hooks,
  layout,
  utils
};
//# sourceMappingURL=index.js.map
